export function isInvalidData(value: unknown): boolean {
  return value === "" || value === null || value === undefined
}

export function localStorageAvailable(): boolean {
  try {
    let x = "@test-local-storage:" + new Date().toISOString()
    localStorage.setItem(x, x)
    localStorage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}

export function isObject(value: unknown) {
  return (
    (typeof value === "object" && value !== null) || typeof value === "function"
  )
}
function isValidObject(val: any) {
  return isObject(val) || Array.isArray(val) || typeof val === "function"
}
function assignProp(obj: { [key: string]: any }, prop: string, value: unknown) {
  if (value === undefined) {
    Reflect.deleteProperty(obj, prop)
  } else {
    obj[prop] = value
  }
  return obj
}
function isValid(key: string, target: object, options?: any) {
  if (typeof options.isValid === "function") {
    return options.isValid(key, target)
  }
  return true
}
function join(segs: unknown[], joinChar: string, options?: any) {
  if (typeof options.join === "function") {
    return options.join(segs)
  }
  return segs[0] + joinChar + segs[1]
}
function split(path: string, splitChar: string, options?: any) {
  if (typeof options.split === "function") {
    return options.split(path)
  }
  return path.split(splitChar)
}
/**
 * 设置value, 自动转化成obj.a.b的深度
 * @param target 对象
 * @param keys 关键值
 * @param value 值内容
 */
export function setValue<T>(
  target = {},
  keys: string[],
  value: unknown
): object {
  if (!isObject(target)) return target
  let obj: { [key: string]: any } = target
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const next = keys[i + 1]
    if (next === undefined) {
      assignProp(obj, key, value)
      break
    }
    if (!isObject(obj[key])) {
      obj[key] = {}
    }
    obj = obj[key]
  }
  return target
}

export function getValue(
  target: { [key: string]: any } = {},
  path: string,
  options?: any
) {
  if (!isObject(options)) {
    options = { default: options }
  }

  if (!isValidObject(target)) {
    return typeof options.default !== "undefined" ? options.default : target
  }

  if (typeof path === "number") {
    path = String(path)
  }

  const isArray = Array.isArray(path)
  const isString = typeof path === "string"
  const splitChar = options.separator || "."
  const joinChar =
    options.joinChar || (typeof splitChar === "string" ? splitChar : ".")

  if (!isString && !isArray) {
    return target
  }

  if (isString && path in target) {
    return isValid(path, target, options) ? target[path] : options.default
  }

  let segs = isArray ? path : split(path, splitChar, options)
  let len = segs.length
  let idx = 0

  do {
    let prop = segs[idx]
    if (typeof prop === "number") {
      prop = String(prop)
    }

    while (prop && prop.slice(-1) === "\\") {
      prop = join([prop.slice(0, -1), segs[++idx] || ""], joinChar, options)
    }

    if (prop in target) {
      if (!isValid(prop, target, options)) {
        return options.default
      }

      target = target[prop]
    } else {
      let hasProp = false
      let n = idx + 1

      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options)

        if ((hasProp = prop in target)) {
          if (!isValid(prop, target, options)) {
            return options.default
          }
          target = target[prop]
          idx = n - 1
          break
        }
      }

      if (!hasProp) {
        return options.default
      }
    }
  } while (++idx < len && isValidObject(target))

  if (idx === len) {
    return target
  }

  return options.default
}
export function hasValue(obj: object, path?: string): boolean {
  if (isObject(obj) && (typeof path === "string" || Array.isArray(path))) {
    return getValue(obj, path)
  }
  return false
}
export function unsetValue(obj: object | any, path: string) {
  if (!isObject(obj)) {
    throw new TypeError("expected an object.")
  }
  if (obj.hasOwnProperty(path)) {
    delete obj[path]
    return obj
  }
  if (hasValue(obj, path)) {
    let segs = path.split(".")
    let last = segs.pop()
    while (segs.length && segs[segs.length - 1].slice(-1) === "\\") {
      last = segs.pop().slice(0, -1) + "." + last
    }
    while (segs.length) {
      path = segs.shift()
      obj = obj[path]
    }
    delete obj[last]
    return obj
  }
  return obj
}

export function parser(data: unknown): any {
  if (typeof data !== "string") return data
  try {
    return JSON.parse(data)
  } catch (e) {
    throw e
  }
}
